/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Accident_PhotosInputs */

const en_case_doc_accident_photos = /** @type {(inputs: Case_Doc_Accident_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accident and damage photos`)
};

const pt_br2_case_doc_accident_photos = /** @type {(inputs: Case_Doc_Accident_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos do acidente e danos`)
};

/**
* | output |
* | --- |
* | "Accident and damage photos" |
*
* @param {Case_Doc_Accident_PhotosInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_accident_photos = /** @type {((inputs?: Case_Doc_Accident_PhotosInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Accident_PhotosInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_accident_photos(inputs)
	return pt_br2_case_doc_accident_photos(inputs)
});